import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import React from "react";
import ParaDescargar from "../clases/paraDescargar";
import styles from "../../styles/main.module.css";
import { useLanguage } from "../../context/LanguageContext";
//-----MUI------------
import { useTheme } from "@mui/material/styles";
import { Typography } from "@mui/material";
import { Box } from "@mui/material";
import { Button, Stack } from "@mui/material";

export default function SeccionTop({ id, isDarkMode, onThemeToggle }) {
  const pdfUrl = process.env.PUBLIC_URL + "/CV_Hernán_Darío_Gomez_Marquez.pdf";
  const theme = useTheme();
  const { language } = useLanguage();

  const translations = {
    es: {
      role: "Desarrollador Full Stack",
      welcome: "Bienvenid@, este es mi portafolio de desarrollador.",
      contactText: "Si quieres ponerte en contacto conmigo puedes escribirme a",
      phrase:
        "Elimina los errores como el sabio depura su mente: línea por línea",
      download: "📄 Descargar CV",
      downloading: "Descargando...",
    },
    en: {
      role: "Full Stack Developer",
      welcome: "Welcome, this is my developer portfolio.",
      contactText: "If you want to get in touch with me, you can write to",
      phrase: "Remove errors as the wise debug their mind: line by line",
      download: "📄 Download CV",
      downloading: "Downloading...",
    },
  };
  return (
    <Box
      id={id}
      component="section"
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: { xs: 3, sm: 4, md: 6 },
        backgroundColor: "transparent",
        color: theme.palette.text.primary,
        transition: "background-color 0.3s ease, color 0.3s ease",
        position: "relative",
      }}
    >
      <Box
        data-aos="flip-down"
        sx={{
          maxWidth: "800px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: "center",
            gap: { xs: 2, sm: 4 },
            mb: 2,
          }}
        >
          <Box
            component="img"
            src={`${process.env.PUBLIC_URL}/images/foto.jpeg`}
            alt="Foto de Hernán"
            sx={{
              width: { xs: "180px", sm: "220px", md: "250px" },
              height: { xs: "180px", sm: "220px", md: "250px" },
              borderRadius: "50%",
              objectFit: "cover",
              boxShadow: `0 8px 32px ${theme.palette.primary.main}40`,
              border: `4px solid ${theme.palette.secondary.main}`,
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              "&:hover": {
                transform: "scale(1.05)",
                boxShadow: `0 12px 40px ${theme.palette.primary.main}60`,
              },
            }}
          />
          <Box sx={{ textAlign: { xs: "center", sm: "left" } }}>
            <Typography
              variant="h2"
              component="h1"
              sx={{
                fontFamily: theme.typography.fontFamily[0],
                fontWeight: 700,
                fontSize: { xs: "2.5rem", sm: "3rem", md: "3.5rem" },
                background: theme.palette.secondary.main,
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                mb: 1,
                lineHeight: 1.2,
              }}
            >
              Hernán Gómez M.
            </Typography>
            <Typography
              variant="h5"
              sx={{
                fontFamily: theme.typography.fontFamily[0],
                fontWeight: 500,
                color: theme.palette.text.secondary,
                fontSize: { xs: "1.2rem", sm: "1.4rem" },
              }}
            >
              {translations[language].role}
            </Typography>
          </Box>
        </Box>

        <Typography
          variant="h6"
          sx={{
            color: theme.palette.text.primary,
            maxWidth: "600px",
            lineHeight: 1.6,
            fontSize: { xs: "1rem", sm: "1.1rem" },
            mb: 1,
          }}
        >
          {translations[language].welcome}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: theme.palette.text.secondary,
            fontSize: { xs: "0.95rem", sm: "1rem" },
            maxWidth: "500px",
            lineHeight: 1.5,
          }}
        >
          {translations[language].contactText}
          <Box
            component="span"
            sx={{
              color: theme.palette.secondary.main,
              fontWeight: 600,
              textDecoration: "underline",
              cursor: "pointer",
              "&:hover": {
                color: theme.palette.error.main,
              },
            }}
          >
            dariog_36@hotmail.com
          </Box>
        </Typography>

        <Typography
          variant="h6"
          className={styles.Tecleado}
          sx={{
            fontFamily: theme.typography.fontFamily[0],
            color: theme.palette.text.primary.main,
            fontStyle: "italic",
            fontSize: { xs: "1rem", sm: "1.2rem" },
            maxWidth: "600px",
            lineHeight: 1.4,
            textAlign: "center",
            position: "relative",
          }}
        >
          {translations[language].phrase}
        </Typography>

        <Stack
          spacing={2}
          direction={{ xs: "column", sm: "row" }}
          sx={{ mt: 2, alignItems: "center" }}
        >
          <Box sx={{ mt: { xs: 2, sm: 0 } }}>
            <ParaDescargar
              rutaArchivo={pdfUrl}
              nombreDescarga="CvHernanDarioGomez.pdf"
              textoBoton={translations[language].download}
              textoDescargando={translations[language].downloading}
            />
          </Box>
        </Stack>

        <Stack
          spacing={3}
          direction="row"
          sx={{
            mt: 3,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              color: theme.palette.secondary.main,
              cursor: "pointer",
              transition: "all 0.3s ease",
              "&:hover": {
                color: theme.palette.error.main,
                transform: "translateY(-2px)",
              },
            }}
          >
            <FontAwesomeIcon icon={faGithub} style={{ fontSize: "1.5rem" }} />
            <Typography
              variant="body1"
              sx={{
                fontFamily: theme.typography.fontFamily[0],
                fontWeight: 500,
                fontSize: "1rem",
              }}
            >
              GitHub
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              color: theme.palette.secondary.main,
              cursor: "pointer",
              transition: "all 0.3s ease",
              "&:hover": {
                color: theme.palette.error.main,
                transform: "translateY(-2px)",
              },
            }}
          >
            <FontAwesomeIcon icon={faLinkedin} style={{ fontSize: "1.5rem" }} />
            <Typography
              variant="body1"
              sx={{
                fontFamily: theme.typography.fontFamily[0],
                fontWeight: 500,
                fontSize: "1rem",
              }}
            >
              LinkedIn
            </Typography>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
}
